<div class="panel-header" (mousedown)="onHeaderMouseDown($event)">
  <span class="panel-title">{{ title() }}</span>
  <button nz-button nzType="text" nzSize="small" (click)="btnClose()" i18n-title title="Close">
    <span nz-icon nzType="close"></span>
  </button>
</div>

<div class="panel-body">
  <div style="background-color: #fff1f0; border: 1px solid #ffa39e; padding: 10px; margin-bottom: 10px; border-radius: 4px; display: flex; align-items: center; gap: 10px;">
    <span nz-icon nzType="warning" nzTheme="fill" style="color: #f52227; font-size: 24px; flex-shrink: 0;"></span>
    <div>
      <strong i18n style="color: #cf1322;">Positioning Failure</strong>
      <p i18n style="margin: 0;">The bucket was not correctly positioned or detected. Please check the scanner physical setup.</p>
      @if (mlErrorDetail) {
        <p i18n style="margin: 5px 0 0 0; font-size: 12px; font-weight: bold;">Reason: {{ mlErrorDetail }}</p>
      }
    </div>
  </div>

  @if (scan().reasons?.length) {
    <app-failure-reason [reasons]="scan().reasons"></app-failure-reason>
  }

  <img
    style="width: 100%"
    nz-image
    i18n-alt alt="scan image"
    [nzFallback]="fallbackImage"
    [nzSrc]="scan().imageUrl ?? fallbackImage"
    (error)="onImageError()" />

  <nz-spin [nzSpinning]="busy()">
    <div nz-row nzLayout="horizontal" style="margin-top: 16px;">
      <div nz-col [nzSpan]="24" style="text-align: start">
        <nz-radio-group
          nzButtonStyle="outline"
          [ngModel]="selectedStatus()"
          (ngModelChange)="onStatusChange($event)">
          <label nz-radio-button nzValue="Failed"
            nz-tooltip i18n-nzTooltipTitle nzTooltipTitle="use this if you going to throw a bucket away and create a new manual PAKA">
            <span nz-icon nzType="close-circle" nzTheme="fill" style="color: red; margin-inline-end: 4px"></span>
            <span i18n>Failed</span>
          </label>
          <label nz-radio-button nzValue="Ignored"
            nz-tooltip i18n-nzTooltipTitle nzTooltipTitle="use this if you will send the same bucket again through the scanner. Example if it was not mixed well and no new Manual Job will be created">
            <span nz-icon nzType="question-circle" nzTheme="fill" style="color: grey; margin-inline-end: 4px"></span>
            <span i18n>Ignored</span>
          </label>
        </nz-radio-group>
      </div>
    </div>

    <div nz-row nzJustify="end" style="margin-top: 10px;">
      <div nz-col>
        <nz-space>
          <button *nzSpaceItem nz-button nzType="default"
            nz-tooltip i18n-nzTooltipTitle nzTooltipTitle="will close the panel without any further action"
            (click)="btnClose()"><span i18n>Close</span>
          </button>
          <button *nzSpaceItem nz-button nzType="primary"
            nz-tooltip i18n-nzTooltipTitle nzTooltipTitle="will scan and inspect again instead of the current image"
            [disabled]="busy()"
            (click)="btnRetake()"><span i18n>Fixed! Retake image</span>
          </button>
        </nz-space>
      </div>
    </div>
  </nz-spin>
</div>

<!-- AC-1/AC-2: Operator reason-picker popup (live branch / C2 only) -->
<app-operator-reason-dialog
  (reasonSelected)="onReasonSelected($event)"
  (cancelled)="onReasonCancelled()"
></app-operator-reason-dialog>
